import { default as Obj } from "@/objects/abstract/Object";

export default class Model extends Obj {
  id;
  created_at;
  updated_at;
  deleted_at;

  initializeAttributes(attributes = {}, map = null, initNullValues = true) {
    if (!map) map = this.getMap();

    map = {
      created_at: Date,
      updated_at: Date,
      deleted_at: Date,
      ...map
    };

    super.initializeAttributes(attributes, map, initNullValues);
  }

  getMap() {
    return {};
  }
}
